export const OCR_FIELD_MAPPING = {
  // Document invoice details mappings
  'documentInvoiceDetails.totalAmount': 'priceTotal',
  'documentInvoiceDetails.invoiceNumber': 'receiptNumber',
  'documentInvoiceDetails.date': 'date',
  'documentInvoiceDetails.paymentDueDate': 'paymentDueDate',
  'documentInvoiceDetails.payedAt': 'payedAt',
  'documentInvoiceDetails.iban': 'payeeIban',
  'documentInvoiceDetails.bic': 'payeeBic',
  'documentInvoiceDetails.bankInstitute': 'payeeBank',
  'documentInvoiceDetails.accountHolder': 'payee',
} as const

export type OcrFieldMapping = typeof OCR_FIELD_MAPPING
export type OcrFieldKey = keyof OcrFieldMapping
export type OcrFieldValue = OcrFieldMapping[OcrFieldKey]
